var _templateObject, _templateObject2;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled, { css } from 'styled-components';
import theme from '../../../Theme/helpers/themeReader';
import Text from '../../../Text';
var Subtitle = styled(Text.Tiny)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  text-transform: uppercase;\n\n  ", "\n"])), function (props) {
  var _theme = theme(props),
      plan = _theme.components.card.plan;

  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      margin-bottom: ", "px;\n\n      color: ", ";\n      font-weight: ", ";\n    "])), plan.subtitle.margin.bottom, plan.subtitle.font.color, plan.subtitle.font.weight);
});
Subtitle.displayName = 'PlanCard.Subtitle';
export default Subtitle;